var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCollapse = function SvgArrowCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.121 8H16.5a1.5 1.5 0 0 1 0 3H10v6.5a1.5 1.5 0 0 1-3 0v-2.379l-3.44 3.44a1.5 1.5 0 0 1-2.12-2.122L4.878 13H2.5a1.5 1.5 0 0 1 0-3H9V3.5a1.5 1.5 0 1 1 3 0v2.379l3.44-3.44a1.5 1.5 0 0 1 2.12 2.122L14.122 8Z"
  })));
};
export default SvgArrowCollapse;